import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, InputLabel, TextField, Tooltip } from "@mui/material";
import { useEffect, useReducer } from "react";
import { useTranslation } from "react-i18next";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import { useUpdateContentModelMutation } from "../../../../../shell/services/instance";
import { ContentModel } from "../../../../../shell/services/types";
import { notify } from "../../../../../shell/store/notifications";
import { useDispatch } from "react-redux";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
interface Props {
  onClose: () => void;
  model: ContentModel;
}
export const RenameModelDialogue = ({
  onClose,
  model
}: Props) => {
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [newModel, updateNewModel] = useReducer((prev: Partial<ContentModel>, next: Partial<ContentModel>) => {
    const newModel = {
      ...prev,
      ...next
    };
    newModel.name = newModel.name.toLowerCase().replace(/\W/g, "_");
    return newModel;
  }, {
    label: model.label,
    name: model.name
  });
  const [updateModel, {
    isLoading,
    isSuccess,
    error
  }] = useUpdateContentModelMutation();
  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess]);
  useEffect(() => {
    if (error) {
      dispatch(notify({
        // @ts-ignore
        message: error?.data?.error || t("schema.renameModelFailedNotify"),
        kind: "warn"
      }));
    }
  }, [error]);
  return <Dialog open onClose={onClose} fullWidth maxWidth="xs" data-sentry-element="Dialog" data-sentry-component="RenameModelDialogue" data-sentry-source-file="RenameModelDialogue.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="RenameModelDialogue.tsx">
        <Box sx={{
        backgroundColor: "blue.50",
        borderRadius: "100%",
        width: "40px",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mb: 1.5
      }} data-sentry-element="Box" data-sentry-source-file="RenameModelDialogue.tsx">
          <DriveFileRenameOutlineRoundedIcon color="info" data-sentry-element="DriveFileRenameOutlineRoundedIcon" data-sentry-source-file="RenameModelDialogue.tsx" />
        </Box>
        {t("schema.renameModelTitle")}
        <Typography variant="body2" sx={{
        mt: 1
      }} color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="RenameModelDialogue.tsx">
          {t("schema.renameModelDescription")}
        </Typography>
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="RenameModelDialogue.tsx">
        <Box display="flex" flexDirection="column" gap={2.5} data-sentry-element="Box" data-sentry-source-file="RenameModelDialogue.tsx">
          <Box data-sentry-element="Box" data-sentry-source-file="RenameModelDialogue.tsx">
            <InputLabel data-sentry-element="InputLabel" data-sentry-source-file="RenameModelDialogue.tsx">
              {t("schema.renameModelDisplayNameLabel")}
              <Tooltip placement="top" title={t("schema.renameModelDisplayNameTooltip")} data-sentry-element="Tooltip" data-sentry-source-file="RenameModelDialogue.tsx">
                <InfoRoundedIcon sx={{
                ml: 1,
                width: "10px",
                height: "10px"
              }} color="action" data-sentry-element="InfoRoundedIcon" data-sentry-source-file="RenameModelDialogue.tsx" />
              </Tooltip>
            </InputLabel>
            <TextField inputProps={{
            maxLength: 100
          }} value={newModel.label} onChange={event => updateNewModel({
            label: event.target.value
          })} fullWidth data-sentry-element="TextField" data-sentry-source-file="RenameModelDialogue.tsx" />
          </Box>
          <Box data-sentry-element="Box" data-sentry-source-file="RenameModelDialogue.tsx">
            <InputLabel data-sentry-element="InputLabel" data-sentry-source-file="RenameModelDialogue.tsx">
              {t("schema.renameModelReferenceIdLabel")}
              <Tooltip placement="top" title={t("schema.renameModelReferenceIdTooltip")} data-sentry-element="Tooltip" data-sentry-source-file="RenameModelDialogue.tsx">
                <InfoRoundedIcon sx={{
                ml: 1,
                width: "10px",
                height: "10px"
              }} color="action" data-sentry-element="InfoRoundedIcon" data-sentry-source-file="RenameModelDialogue.tsx" />
              </Tooltip>
            </InputLabel>
            <TextField inputProps={{
            maxLength: 100
          }} value={newModel.name} onChange={event => updateNewModel({
            name: event.target.value
          })} fullWidth helperText={newModel.name !== model.name && t("schema.renameModelReferenceIdHelperText")} sx={{
            "& .MuiFormHelperText-root": {
              color: "error.main"
            }
          }} data-sentry-element="TextField" data-sentry-source-file="RenameModelDialogue.tsx" />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="RenameModelDialogue.tsx">
        <Button onClick={onClose} color="inherit" data-sentry-element="Button" data-sentry-source-file="RenameModelDialogue.tsx">
          {t("common.cancel")}
        </Button>
        <Button onClick={() => updateModel({
        ZUID: model.ZUID,
        body: newModel
      })} loading={isLoading} variant="contained" data-sentry-element="Button" data-sentry-source-file="RenameModelDialogue.tsx">
          {t("common.save")}
        </Button>
      </DialogActions>
    </Dialog>;
};